module.exports = __webpack_public_path__ + "img/6.4ea4f11c.png";